import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.raf = true;

        window.requestAnimationFrame(this._raf.bind(this));
    }

    disconnect() {
        this.raf = false;
        this.element.removeAttribute('style');
    }

    _raf() {
        const footer = document.getElementById('footer');

        if (footer) {
            this.element.style.bottom = 0;

            const footerTop = footer.getBoundingClientRect().top;
            const menuBottom = this.element.getBoundingClientRect().bottom;
            const offset = Math.max(0, menuBottom - footerTop);

            if (offset > 0) {
                this.element.style.bottom = `${offset}px`;
            }
        }

        if (this.raf) {
            window.requestAnimationFrame(this._raf.bind(this));
        }
    }
}
